import { Footer, FooterText } from "./FooterElements";

export default function SiteFooter() {
  return (
    <Footer>
      <FooterText>SciWISE Journal 2025/26</FooterText>
    </Footer>
  );
}